export default "__VITE_ASSET__2532ba51__"